let loadTrigger = document.getElementById('js-car');
if (loadTrigger) {

    let isLoading = false;
    document.addEventListener('scroll', function(event) {
        let viewHeight = document.documentElement.clientHeight;
        if (!isLoading && loadTrigger.getBoundingClientRect().bottom < viewHeight) {
            loadTrigger.classList.add('run')
            isLoading = true;
        }
    });
}
let floorTooltip = document.querySelector('.js-floor-tooltip');
let floorTooltipNumber = document.querySelector('.js-floor-tooltip-number');
let floorTooltipFree = document.querySelector('.js-floor-tooltip-free');
let body = document.body;
let docEl = document.documentElement;
window.showFloor = function(el) {
    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let top = scrollTop + el.getBoundingClientRect().top - 150;
    floorTooltip.style.top = top + 'px';
    floorTooltipNumber.innerHTML = el.dataset.number;
    floorTooltipFree.innerHTML = el.dataset.free;

    floorTooltip.classList.remove('d-none');
    el.classList.remove('-is-hide');
}
window.hideFloor = function(el) {
    el.classList.add('-is-hide');
    floorTooltip.classList.add('d-none');
}